export default __webpack_public_path__ + "6022f77ad0244040bd898dc931ef6857.png";